const GENDER = ["Female", "Male", "Non-binary/non-conforming", "Prefer not to respond"];

export default GENDER;
